// @core/api/endpoints/subscription/list_tenant_subscriptions.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListProductTenantsResponse,
} from '../../../types/subscription';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/subscription';

/**
 * List tenant's product subscriptions
 * Returns all products the tenant is subscribed to with their subscription status and plan details.
 */
export async function ListTenantSubscriptions(
  tenant_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListProductTenantsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tenants/:tenant_id/products`;
  requestPath = requestPath.replace(':tenant_id', encodeURIComponent(tenant_id));
  const requestOptions = options;
  return client.get<ListProductTenantsResponse>(requestPath, { ...requestOptions, params });
}
